import React, { useState, useEffect } from "react";
import moment from "moment";
import "./modal.scss";

export default function CitationWindow(props) {
  const { info } = props;
  const path = window.location.pathname;
  const main = window.location.origin;
  const url = main + path;
  const [citation, setCitation] = useState([]);
  const citeTypes = [
    {
      type: "Chicago",
      placeholder:
        "[document/item being cited, date of item], Box [#], Folder [#]",
    },
    {
      type: "MLA",
      placeholder:
        "[document/item being cited, date of item], Box [#], Folder [#]",
    },
  ];

  //   Format based on conversation with stakeholder 06/28/2021
  // Chicago style:
  // [document/item being cited, date of item], Box [#], Folder [#], <prefercite> value, date accessed, URL
  // MLA:
  // [document/item being cited, date of item], <prefercite> value, date accessed, URL
  // The placeholder info in brackets [] would be part of the auto-generated citation.

  useEffect(() => {
    if (info["<strong>Preferred Citation</strong>"] && info !== "ops") {
      setCitation([
        `<div>${info["<strong>Preferred Citation</strong>"]}</div>`,
      ]);
    } else {
      setCitation([
        "<div> Apologies, it does not appear that any citation information was provided for this resource.</div>",
      ]);
    }
  }, [info]);

  return props.open ? (
    <div className="modal">
      <div className="modal_content mx-auto">
        <button className="close" onClick={() => props.close(false)}>
          &times;
        </button>
        <p className="modal_header">Preferred Citation</p>
        <div className="card-text">
          {citeTypes.map((el, i) => (
            <div key={i}>
              <h5 className="card-title">{el.type}</h5>
              <em>{el.placeholder}</em>
              {citation.map((item, i) => (
                <div key={i}>
                  <p tabIndex="0" dangerouslySetInnerHTML={{ __html: item }} />
                </div>
              ))}
              <p>
                {" "}
                {moment().format("YYYY/MM/DD")}, {url}{" "}
              </p>
              <br />
            </div>
          ))}
        </div>
        <em>
          Note that these citations have been automatically generated, please
          verify that citation is correct and contains all necessary
          information.
        </em>
      </div>
    </div>
  ) : null;
}
